import { Application } from '@hotwired/stimulus';
import StimulusControllerResolver from 'stimulus-controller-resolver';
import * as Turbo from '@hotwired/turbo';

import '../assets/img/favicon/apple-touch-icon.png';
import '../assets/img/favicon/favicon-16x16.png';
import '../assets/img/favicon/favicon-32x32.png';

import '../assets/img/pdf-bg.jpg';
import '../assets/img/email-logo.png';
import '../assets/img/email-logo-wide.png';
import '../assets/img/trustmark.png';
import '../assets/img/gradient.webp';
import '../assets/img/footer.webp';
import '../assets/img/hero-01.webp';
import '../assets/img/icon-cart.svg';
import '../assets/img/icon-check.svg';
import '../assets/img/icon-chevron.svg';
import '../assets/img/icon-chevron.png';
import '../assets/img/icon-close.svg';
import '../assets/img/icon-download.svg';
import '../assets/img/icon-facebook.svg';
import '../assets/img/icon-instagram.svg';
import '../assets/img/icon-phone.svg';
import '../assets/img/icon-whatsapp.svg';
import '../assets/img/icon-lock.svg';
import '../assets/img/icon-play.svg';
import '../assets/img/icon-search.svg';
import '../assets/img/logo-wide.svg';
import '../assets/img/logo-black.svg';
import '../assets/img/webwinkelkeur.svg';
import '../assets/img/made-in-holland.svg';
import '../assets/img/og-image.jpg';

import '../assets/img/payment/giropay.svg';
import '../assets/img/payment/ideal-wero.svg';
import '../assets/img/payment/inghomepay.svg';
import '../assets/img/payment/mastercard.svg';
import '../assets/img/payment/paypal.svg';
import '../assets/img/payment/sofort.svg';
import '../assets/img/payment/visa.svg';

// Start application
const application = Application.start();
StimulusControllerResolver.install(application, async (controllerName) => (
  (await import(`./controllers/${controllerName}_controller.js`)).default
));

// Recaptcha callback
window.dispatchRecaptchaEvent = (...args) => {
  const event = document.createEvent('Events');
  event.initEvent('recaptcha-callback', true, true);
  event.args = args;
  window.dispatchEvent(event);
};

// Start Turbo
Turbo.start();

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('HMR');
  });
}
